import React from 'react';

import { RHP } from 'providers';
import { useForm } from 'components/form';

import * as Form from 'components/form';
import * as Page from 'components/page';

import { Ruler } from 'components/page/ruler/PageRuler';

import { RankingInterestCard } from '../components';

export function StartupStep4(props) {
    const { vars, putStartupRankingApplication } = props.useRankingStartup;
    const { startupDetails, ranking } = vars;

    // Initialize a new form handler
    const form = useForm({
        specialAwards: startupDetails.rankingData?.[ranking.id]?.specialAwards || {},
        ...vars.application,
    });

    // Check for previous step conclusion
    if (!vars.application.steps || vars.application.steps.step3 !== true) {
        RHP.replace('/ranking/br/startup/');
        return null;
    }

    // Handle form submitions
    const onSubmit = values => {
        const payload = {
            ...vars.application,
            ...values,
        };
        // Set the current step to true;
        if (!payload.steps) payload.steps = {};
        payload.steps.step4 = true;

        return putStartupRankingApplication(payload)
            .then(() => RHP.push('/ranking/br/startup/step5'))
            .catch(() => form.submited());
    };

    const propsForm = { ...props, form, onSubmit };

    const evSubmit = ev => form.handleSubmit(ev, onSubmit);
    return (
        <Page.Page name="StartupStep4" back="/ranking/br/startup">
            <Page.Title>{props.t('StartupStep4.title')}</Page.Title>
            <Page.Descr>{props.t('StartupStep4.descr', { rankingYear: ranking.year })}</Page.Descr>

            <Ruler />

            <Form.Form name="StartupStep4Form" onSubmit={evSubmit}>
                <RankingInterestCard
                    {...propsForm}
                    name="social"
                    title={props.t('RankingInterestCard.title.social')}
                    descr={props.t('RankingInterestCard.descr.social')}
                    reasonText={props.t('RankingInterestCard.reason.social')}
                    appliedText={props.t('RankingInterestCard.join')}
                />
                <RankingInterestCard
                    {...propsForm}
                    name="sustainability"
                    title={props.t('RankingInterestCard.title.sustainability')}
                    descr={props.t('RankingInterestCard.descr.sustainability')}
                    reasonText={props.t('RankingInterestCard.reason.sustainability')}
                    appliedText={props.t('RankingInterestCard.join')}
                />
                <RankingInterestCard
                    {...propsForm}
                    name="accessibility"
                    title={props.t('RankingInterestCard.title.accessibility')}
                    descr={props.t('RankingInterestCard.descr.accessibility')}
                    reasonText={props.t('RankingInterestCard.reason.accessibility')}
                    appliedText={props.t('RankingInterestCard.join')}
                />
                <RankingInterestCard
                    {...propsForm}
                    name="black"
                    title={props.t('RankingInterestCard.title.black')}
                    descr={props.t('RankingInterestCard.descr.black')}
                    reasonText={props.t('RankingInterestCard.reason.black')}
                    appliedText={props.t('RankingInterestCard.join2')}
                />
                <RankingInterestCard
                    {...propsForm}
                    name="women"
                    title={props.t('RankingInterestCard.title.women')}
                    descr={props.t('RankingInterestCard.descr.women')}
                    reasonText={props.t('RankingInterestCard.reason.women')}
                    appliedText={props.t('RankingInterestCard.join2')}
                />
                <RankingInterestCard
                    {...propsForm}
                    name="senior"
                    title={props.t('RankingInterestCard.title.senior')}
                    descr={props.t('RankingInterestCard.descr.senior')}
                    reasonText={props.t('RankingInterestCard.reason.senior')}
                    appliedText={props.t('RankingInterestCard.join2')}
                />
                <Form.Submt {...form} text={props.t('glossary:save')} />
            </Form.Form>
        </Page.Page>
    );
}
export default StartupStep4;
